import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FirmwareDownloadComponent } from '@main/pages/firmware-download/firmware-download.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private modalController: ModalController) {}

  public dismissModal(id: string): void {
    this.modalController.dismiss({}, '', id);
  }

  private presentModal(modal: Promise<HTMLIonModalElement>) {
    modal.then((modalRes) => modalRes.present());
  }

  public async closeDetailsModal(): Promise<void> {
    await this.modalController.dismiss('SystemDetailsComponent');
  }

  public async openFirmwareDownloadModal() {
    const modal = await this.modalController.create({
      id: 'FirmwareDownloadComponent',
      component: FirmwareDownloadComponent,
      cssClass: 'full-width',
      backdropDismiss: false,
      componentProps: {},
    });

    await modal.present();

    return modal.onDidDismiss();
  }
}
